// 两端与头像角标共用八齿轮廓，仅改变素材边缘，保留原图标和背景。
const vertices = Array.from({ length: 24 }, (_, index) => {
  const angle = -Math.PI / 2 + (index * Math.PI) / 12;
  const radius = index % 3 === 0 ? 55 : 49;
  return [64 + Math.cos(angle) * radius, 64 + Math.sin(angle) * radius];
});

export const creatorIdentityBadgePoints = vertices.map(([x, y]) => `${x},${y}`).join(' ');

export const creatorIdentityBadgeClipPath = `polygon(${vertices
  .map(([x, y]) => `${(x / 128) * 100}% ${(y / 128) * 100}%`)
  .join(', ')})`;

// 使用内嵌素材兜底，图标请求失败时不再依赖额外网络请求。
export const creatorIdentityFallbackIconUrl = `data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128"><polygon points="${creatorIdentityBadgePoints}" fill="#24272c"/><g transform="translate(5.5 10.5) scale(0.56)"><path d="M47.5601 61.5508V84.3808C47.5601 86.4608 47.7201 88.5308 48.0801 90.5708C49.7601 100.041 56.6001 123.171 83.5601 125.551C117.56 128.551 122.56 91.5508 122.56 84.5508C122.56 72.5508 115.56 62.5508 104.56 62.5508C93.5601 62.5508 85.5601 70.5508 85.5601 84.5508C85.5601 95.5508 93.5601 124.551 123.56 125.551C147.34 126.341 156.67 103.881 159.52 94.5408C160.23 92.2208 160.56 89.8108 160.56 87.3908V61.5608" fill="none" stroke="#fff" stroke-width="18" stroke-linecap="round"/></g></svg>`
)}`;
